'use client';

import { useRef } from 'react';
import { memo } from 'react';
import { CircularProgress } from '@mui/material';
import { Html } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

interface LoadingSpinnerProps {
  size?: number;
}

function LoadingSpinnerComponent({ size = 24 }: LoadingSpinnerProps) {
  return <CircularProgress size={size} />;
}

// Canvas-specific loading spinner with centered positioning
function CanvasLoadingSpinnerComponent() {
  const groupRef = useRef<THREE.Group>(null);

  useFrame(({ clock }) => {
    if (groupRef.current) {
      groupRef.current.rotation.z = clock.getElapsedTime() * 2;
    }
  });

  return (
    <group ref={groupRef}>
      <mesh>
        <ringGeometry args={[0.5, 0.7, 32]} />
        <meshBasicMaterial color="#1976d2" transparent opacity={0.7} />
      </mesh>
      <mesh>
        <ringGeometry args={[0.5, 0.7, 32]} />
        <meshBasicMaterial color="#1976d2" transparent opacity={0.3} />
      </mesh>
      <Html center>
        <div style={{ color: '#666', textAlign: 'center', marginTop: '20px' }}>
          Loading model...
        </div>
      </Html>
    </group>
  );
}

export const LoadingSpinner = memo(LoadingSpinnerComponent);
export const CanvasLoadingSpinner = memo(CanvasLoadingSpinnerComponent);
